<template>
        <Header/>

    <div class="blog-page-bg">
      <div class="shapes shape-one"></div>
      <div class="shapes shape-two"></div>
      <div class="shapes shape-three"></div>
      <div class="container">
        <div class="row">
          <div class="col-lg-11 feature-blog-one width-lg blog-details-post-v1">
            <div class="post-meta">
              <img :src="require(`@/assets/images/blog/eu.png`)" alt="" class="image-meta">
              <div style="display: flex; align-items: center; padding: 5% 20%;">
                    <h3 class="title" style="font-size: 60px; color: blue; margin: 0;">
                        EU Funding
                    </h3>
                    <img
                       :src="require(`@/assets/images/blog/eu.avif`)"
                        alt="EU Flag"
                        style="height: 80px; margin-left: 30px;"
                    />
                    </div>             
              <!-- Static Text Section -->
              <div class="project-details">
                <p>
                  The project aims to develop the Roboquark platform — an AI-powered, hands-on robotics education solution designed for learners +15. The platform combines modular robot kits, a cloud-based coding environment, and an AI learning assistant to help users gain practical robotics and automation skills. It enables learners to build and program real robots remotely, while supporting institutions with scalable tools for training and engagement.
                </p>
                
                <div class="eu-funding-details">
                  <p>The project is funded by the European Union – NextGenerationEU</p>
                  <p>Project name: Development of the AI-based robotics education platform Roboquark.</p>
                  <p>Project implementer: Roboquark, MB</p>
                  <p>Measure: Joint project "To encourage the development of innovative products or prototypes of innovative products by startups in the field of EdTech".</p>
                  <p>Total project value: EUR 59,296.65.</p>
                  <p>EU funding share: EUR 59,296.65.</p>
                  <p>Project duration: March 2025- March 2026.</p>
                </div>
              </div>
              
              <!-- Dynamic Blog Content -->
  
              <div class="d-sm-flex align-items-center justify-content-between share-area">
                <!-- <ul class="tag-feature d-flex">
                  <li>Tag: &nbsp;</li>
                  <li><a href="#">business,</a></li>
                  <li><a href="#">makreting,</a></li>
                  <li><a href="#">tips</a></li>
                </ul>
                <ul class="share-option d-flex align-items-center">
                  <li>Share</li>
                  <li><a href="#" style="background: #F6616F;">
                      <i class="fa fa-google-plus" aria-hidden="true"></i></a>
                  </li>
                  <li><a href="#" style="background: #41CFED;">
                      <i class="fa fa-twitter" aria-hidden="true"></i></a></li>
                  <li><a href="#" style="background: #588DE7;">
                      <i class="fa fa-facebook" aria-hidden="true"></i></a></li>
                </ul> -->
              </div>
            </div> <!-- /.post-meta -->
          </div>
          <div class="col-lg-4 col-md-6">
            <!-- blog side bar start -->
            <!-- blog side bar end -->
          </div>
        </div>
      </div>
    </div>
    <Footer />    
  </template>
  
  <script>
import Header from '../components/common/Headers/HeaderFive.vue';
import Footer from '../components/common/Footers/FooterSeven.vue';

  export default {
    name: 'EUfunding',
    components: {
        Footer,
        Header
    
    },
  }
  </script>
  
  <style scoped>
  .project-details {
    margin: 2rem 0;
  }
  
  .eu-funding-details {
    margin-top: 1.5rem;
    padding: 1.5rem;
    background-color: #f8f9fa;
    border-left: 4px solid #0d6efd;
  }
  
  .eu-funding-details p {
    margin-bottom: 0.75rem;
  }
  </style>